import { ICardCreateRequest, ISquareTokenizeResponse } from "./card-create.interface";
import { CardCreateFormType } from "./card-create.schema";

export const mapToCardCreateRequest = (
  tokenize: ISquareTokenizeResponse,
  cardCreateForm: CardCreateFormType,
): ICardCreateRequest => {
  return {
    last4: tokenize.details.card.last4,
    expMonth: tokenize.details.card.expMonth,
    expYear: tokenize.details.card.expYear,
    token: tokenize.token,
    setAsdefault: cardCreateForm.setAsdefault || false,
  };
};
